/**
 * Utilitários de formatação para exibição de dados
 */

/**
 * Formata CPF para exibição
 * @param cpf - CPF com apenas números
 * @returns CPF formatado (XXX.XXX.XXX-XX) ou valor original se inválido
 */
export function formatCPF(cpf: string | null | undefined): string {
  if (!cpf) return "-";
  
  const numbers = cpf.replace(/\D/g, "");
  if (numbers.length !== 11) return cpf;
  
  return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

/**
 * Formata CNPJ para exibição
 * @param cnpj - CNPJ com apenas números
 * @returns CNPJ formatado (XX.XXX.XXX/XXXX-XX) ou valor original se inválido
 */
export function formatCNPJ(cnpj: string | null | undefined): string {
  if (!cnpj) return "-";
  
  const numbers = cnpj.replace(/\D/g, "");
  if (numbers.length !== 14) return cnpj;
  
  return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

/**
 * Formata CPF ou CNPJ automaticamente baseado no tamanho
 * @param value - CPF ou CNPJ com apenas números
 * @returns Documento formatado ou "-" se vazio
 */
export function formatCPFOrCNPJ(value: string | null | undefined): string {
  if (!value) return "-";
  
  const numbers = value.replace(/\D/g, "");
  
  if (numbers.length === 11) {
    return formatCPF(numbers);
  } else if (numbers.length === 14) {
    return formatCNPJ(numbers);
  }
  
  return value;
}

/**
 * Formata telefone celular brasileiro
 * @param phone - Telefone com apenas números (incluindo DDD)
 * @returns Telefone formatado ((XX) XXXXX-XXXX) ou valor original
 */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return "-";
  
  const numbers = phone.replace(/\D/g, "");
  
  // (XX) XXXXX-XXXX - celular com 11 dígitos
  if (numbers.length === 11) {
    return numbers.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  
  // (XX) XXXX-XXXX - fixo com 10 dígitos
  if (numbers.length === 10) {
    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  
  return phone;
}

/**
 * Formata CEP brasileiro
 * @param cep - CEP com apenas números
 * @returns CEP formatado (XXXXX-XXX) ou valor original
 */
export function formatCEP(cep: string | null | undefined): string {
  if (!cep) return "-";
  
  const numbers = cep.replace(/\D/g, "");
  if (numbers.length !== 8) return cep;
  
  return numbers.replace(/(\d{5})(\d{3})/, "$1-$2");
}
